<template>
  <div v-bind="$attrs">
    <slot v-bind="{isMapActive, toggleMapView}" />
    <transition name="slide-left">
      <div class="map-holder" v-if="isMapActive">
        <SolutionMap :isMapActive="isMapActive" @show-details="onShowPoiDetailsFromMap" @toggle-map="toggleMapView">
          <!-- <template v-slot:toggle> -->
          <!-- <div></div> -->
          <!-- </template> -->
        </SolutionMap>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {defineComponent, ref} from '@vue/composition-api';
import {useSolutionViews} from '../../solution-views/solution-views';
import SolutionMap from '../../summary-page/solution-map.vue';
import {getUserId} from '@/services/auth-shared';
import {trackMapsView} from '@/store/api/trackBtnClick';

Vue.use(VueCompositionAPI);

export default defineComponent({
  components: {
    SolutionMap,
  },
  setup(_, {root}) {
    const {onShowPoiDetailsFromMap, solution} = useSolutionViews(root);
    const isMapActive = ref(false);
    const toggleMapView = () => {
      if (!isMapActive.value) {
        const userId = getUserId();
        const problemId = solution.value?.problem_id;
        trackMapsView(userId, problemId);
      }

      isMapActive.value = !isMapActive.value;
    };
    return {
      isMapActive,
      onShowPoiDetailsFromMap,
      toggleMapView,
    };
  },
});
</script>

<style lang="sass" scoped>
@import '../../solution-views/vue-transitions.scss'

.map-holder
  position: absolute
  top: 0
  left: 0
  width: 100%
  transform: translateZ(0)
  z-index: 6
  background: #fff

.map-toggle > .map-toggle-label
  margin: 0 0.5em
  color: var(--toggle-text-color)
  position: relative
  top: 2px
  display: inline-block
  font-weight: 400
  font-size: 18px
  line-height: 118.14%
  letter-spacing: -0.005em
</style>
